/**
 * Canonical license-status -> list-builder chip variant (PD-14745).
 *
 * Single source for the Status cell across every license/registry list so the
 * colors can never drift between surfaces (the /licenses list, the registry
 * list, the embedded license/audit tables, the client-licenses tab). Spread
 * into each config's `colorRule.statusMap`.
 *
 * Semantics (mirrors LicenseStatusBadgeSelector + LicenseBreakdownChart):
 *   success  Active                                   (valid, can order)
 *   warning  Pending / Probation / Limited            (attention / on watch)
 *   danger   Expired / Suspended / Revoked /
 *            Surrendered / Denied                      (problem)
 *   default  Cancelled / Superseded / Retired /
 *            Inactive / Deceased / Unknown / Other     (neutral / closed out)
 */
import type { ColorValue } from '../../types';

export const LICENSE_STATUS_STYLE_MAP: Record<string, ColorValue> = {
	Active: { type: 'success' },
	Pending: { type: 'warning' },
	Probation: { type: 'warning' },
	// Board-restricted but in force: can order, needs review — the same
	// allow-with-watch posture as Probation, so the same chip.
	Limited: { type: 'warning' },
	Expired: { type: 'danger' },
	Suspended: { type: 'danger' },
	Revoked: { type: 'danger' },
	Surrendered: { type: 'danger' },
	Denied: { type: 'danger' },
	Cancelled: { type: 'default' },
	// PD-16488: the board replaced the record — closed out, like Cancelled.
	Superseded: { type: 'default' },
	Retired: { type: 'default' },
	Inactive: { type: 'default' },
	Deceased: { type: 'default' },
	Unknown: { type: 'default' },
	Other: { type: 'default' },
};
